const SELECTORS = {
  CONTAINER: '[data-gift-card-recipient]',
  TOGGLE: '[data-gift-card-recipient-toggle]',
  FIELDS: '[data-gift-card-recipient-fields]',
  EMAIL: '[data-gift-card-recipient-email]',
  NAME: '[data-gift-card-recipient-name]',
  MESSAGE: '[data-gift-card-recipient-message]',
  SEND_ON: '[data-gift-card-recipient-send-on]',
  CONTROL: '[data-gift-card-recipient-control]',
  OFFSET: '[data-gift-card-recipient-offset]'
};

const initGiftCardRecipient = () => {
  const containers = document.querySelectorAll(SELECTORS.CONTAINER);
  if (!containers.length) return;

  containers.forEach((container) => {
    if (container.dataset.giftCardRecipientInit === 'true') return;

    const toggle = container.querySelector(SELECTORS.TOGGLE);
    const fieldsWrapper = container.querySelector(SELECTORS.FIELDS);
    const emailInput = container.querySelector(SELECTORS.EMAIL);
    const nameInput = container.querySelector(SELECTORS.NAME);
    const messageInput = container.querySelector(SELECTORS.MESSAGE);
    const sendOnInput = container.querySelector(SELECTORS.SEND_ON);
    const controlInput = container.querySelector(SELECTORS.CONTROL);
    const offsetInput = container.querySelector(SELECTORS.OFFSET);

    if (!toggle || !fieldsWrapper) return;

    const visibleInputs = [emailInput, nameInput, messageInput, sendOnInput].filter(Boolean);
    const hiddenInputs = [controlInput, offsetInput].filter(Boolean);
    const allInputs = [...visibleInputs, ...hiddenInputs];

    const showFields = () => {
      fieldsWrapper.classList.remove('hidden');
      fieldsWrapper.classList.add('flex');
      allInputs.forEach((input) => { input.disabled = false; });
      if (offsetInput) {
        offsetInput.value = new Date().getTimezoneOffset();
      }
    };

    const hideFields = () => {
      fieldsWrapper.classList.add('hidden');
      fieldsWrapper.classList.remove('flex');
      visibleInputs.forEach((input) => { input.value = ''; });
      allInputs.forEach((input) => { input.disabled = true; });
    };

    toggle.addEventListener('change', () => {
      if (toggle.checked) {
        showFields();
      } else {
        hideFields();
      }
    });

    container.dataset.giftCardRecipientInit = 'true';
  });
};

export default initGiftCardRecipient;
